/** @format */
function handleInsertedAndUpdate(el, binding) {
    setTimeout(() => {
        const toggleButton = document.querySelector(
            '.gst-add-hotel-reservation__toggle-view.v-btn'
        );
        if (toggleButton) {
            const elementPosition = el.getBoundingClientRect();
            const viewPortHeight = window.innerHeight;
            if (el && binding.value)
                toggleButton.style.bottom = `${viewPortHeight - elementPosition.top}px`;
        }
    }, 0);
}
// binding object represents the Totals Container element where the price for hotels or tickets is displayed
export default {
    inserted: function (el, binding) {
        handleInsertedAndUpdate(el, binding);
    },
    update: function (el, binding) {
        handleInsertedAndUpdate(el, binding);
    },
};
